export type ScriptPosition = 'head' | 'bodyOpen' | 'bodyClose';
export type ScriptType = 'inline' | 'external';

export enum ScriptStatus {
    Idle = 'idle',
    Loading = 'loading',
    Completed = 'completed',
    Failed = 'failed',
}

export enum FeatureName {
    Solitics = 'solitics',
    ProLine = 'ProLine',
}

export interface FeatureFlagScript {
    enabled: boolean;
    position: ScriptPosition;
    type: ScriptType;
    content: string;
}

export type FeatureFlags = Record<FeatureName, FeatureFlagScript>;
